import React,{Fragment,useContext, useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import loading_img from "../../../images/profile/loading.gif";
import { GlobalSet } from '../global/GlobalProvider';
import Slider from "react-slick";
import axios from "axios";
import { Row, Col, Card, Carousel,Accordion } from 'react-bootstrap'
import swal from "sweetalert";
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';
const Home = () => {
    const { changeBackground } = useContext(ThemeContext);
    useEffect(() => {
        changeBackground({ value: "dark", label: "Dark" });
    }, []);

   const { BaseUrl } = GlobalSet();
   const [salider, setSalider] = useState([]); 
   const [homeCasino, setCasino] = useState([]);
   const [homeTopSlider, TopSlider] = useState([]);
   const [homeitem, setHomeItem] = useState([]);   
   const { t } = useTranslation();
   const [activeTab, setActiveTab] = useState('');

   const authToken = localStorage.getItem("auth_token"); 

  // Image sources
  const banner_sports = BaseUrl + "public/appssource/all_slider/banner_sports.jpg";
  const banner_virtualsports = BaseUrl + "public/appssource/all_slider/banner_virtualsports.jpg";
  const banner_skyexchangeBlog = BaseUrl + "public/appssource/all_slider/banner_skyexchangeBlog.jpg";
  const banner_kabaddi = BaseUrl + "public/appssource/all_slider/banner_kabaddi.jpg";

  const row1Images = [banner_sports, banner_virtualsports, banner_skyexchangeBlog];
  const row2Images = [banner_kabaddi, banner_skyexchangeBlog, banner_virtualsports];

  // State to manage indices of images for two rows
  const [row1Index, setRow1Index] = useState(0);
  const [row2Index, setRow2Index] = useState(0);

  // Auto change images every 2 seconds
  useEffect(() => {
    const interval1 = setInterval(() => {
      setRow1Index((prev) => (prev + 1) % row1Images.length);
    }, 2000);

    const interval2 = setInterval(() => {
      setRow2Index((prev) => (prev + 1) % row2Images.length);
    }, 2000);

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [row1Images.length, row2Images.length]);

  // Functions to manually change images for Row 1
  const prevRow1Image = () => {
    setRow1Index((prev) => (prev - 1 + row1Images.length) % row1Images.length);
  };

  const nextRow1Image = () => {
    setRow1Index((prev) => (prev + 1) % row1Images.length);
  };

  // Functions to manually change images for Row 2
  const prevRow2Image = () => {
    setRow2Index((prev) => (prev - 1 + row2Images.length) % row2Images.length);
  };

  const nextRow2Image = () => {
    setRow2Index((prev) => (prev + 1) % row2Images.length);
  };
/*.....product code........*/
  const [loading, setLoading] = useState(true);
  const data = {
       key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
       }
  const APiResponse = () => {
      axios.post('/home-data',data)
      .then(response=>{
         setSalider(response.data.slider)
         setCasino(response.data.home_casino)
         TopSlider(response.data.top_slider)
         setHomeItem(response.data.home_items)
         setLoading(false); 
       })
   .catch(error=>{
         console.log(error)
     });
   }
    useEffect(()=>{
   const interval = setInterval(
      (function callApi() {
        APiResponse();
        return callApi;
      })(),
      70000000
    );
    return () => clearInterval(interval);
    },[]);


//mobile odds option
  const casino_game_s = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 100,
    slidesToShow: 10,
    slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1560,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 5,
                },
            },  
            {
                breakpoint: 640,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 4,
                },
            },
        ],
  };
  const casino_home_s = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 100,
    slidesToShow: 10,
    slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1560,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 5,
                },
            },  
            {
                breakpoint: 640,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 4,
                },
            },
        ],
  };


  const teams = [
    { id: 'Exclusive', name: 'Exclusive', img: BaseUrl + 'public/appssource/sports_icons/Exclusive.png' },
    { id: 'Sports', name: 'Sports', img: BaseUrl + 'public/appssource/sports_icons/Sports.png' },
    { id: 'Casino', name: 'Casino', img: BaseUrl + 'public/appssource/sports_icons/Live.png' },
    { id: 'Slots', name: 'Slots', img: BaseUrl + 'public/appssource/sports_icons/slots.png' },
    { id: 'Type', name: 'Type', img: BaseUrl + 'public/appssource/sports_icons/Type.png' },
    { id: 'Live', name: 'Live', img: BaseUrl + 'public/appssource/sports_icons/Live.png' },
    { id: 'Table', name: 'Table', img: BaseUrl + 'public/appssource/sports_icons/Table.png' },
    { id: 'Fishing', name: 'Fishing', img: BaseUrl + 'public/appssource/sports_icons/fishing.png' },
    { id: 'Lottery', name: 'Lottery', img: BaseUrl + 'public/appssource/sports_icons/lottery_h.png' },
  ];
   const renderTabContent = (id) => {
    const content = {
      Exclusive: (
        <div className="row d-flex justify-content-center">
        </div>
      ),
      Sports: (
        <div className="row d-flex justify-content-center">
          {[
            { name: 'Exchange', clickUrl: 'sportsbook', imgPath: BaseUrl + '/public/appssource/sports_icons/Exchange.png' },
            { name: 'Sportsbook', clickUrl: 'sportsbook', imgPath: BaseUrl + '/public/appssource/sports_icons/Sportsbook.png' },
            { name: 'Virual', clickUrl: 'sportsbook?bt-path=%2Fecricket-305', imgPath: BaseUrl + '/public/appssource/sports_icons/Virual.png' },
            { name: 'Racing', clickUrl: 'sportsbook?bt-path=%2Fehorse-racing-315', imgPath: BaseUrl + '/public/appssource/sports_icons/Horse_Racing_home.png' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="50"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Casino: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'ROYALGAMING', clickUrl: 'home-game/all-game?provider=rzugi', imgPath: BaseUrl + '/public/appssource/all_icon/1_casino_royal.webp' },
            { name: 'JILI', clickUrl: 'home-game/all-game?provider=lotto-instant-win', imgPath: BaseUrl + '/public/appssource/all_icon/2_casino_JILI.webp' },
            { name: 'KINGMAKER', clickUrl: 'home-game/all-game?provider=ho-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/3_casino_KINGMAKER.webp' },
            { name: 'EVOLUTION', clickUrl: 'home-game/all-game?provider=betgames', imgPath: BaseUrl + '/public/appssource/all_icon/4_casino_EVOLUTION.webp' },
            { name: 'BETGAMES', clickUrl: 'home-game/all-game?provider=cti-nteractive', imgPath: BaseUrl + '/public/appssource/all_icon/5_casino_BETGAMES.webp' },
            { name: 'REDTIGER', clickUrl: 'home-game/all-game?provider=evolution2', imgPath: BaseUrl + '/public/appssource/all_icon/6_casino_REDTIGER.webp' },
            { name: 'SPADEGAMING', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/7_casino_SPADEGAMING.webp' },
            { name: 'FC', clickUrl: 'home-game/all-game?provider=amigo-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/8_casino_FC.webp' },
            { name: 'JDB', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/9_casino_JDB.webp' },
            { name: 'YL', clickUrl: 'home-game/all-game?provider=gamebeat', imgPath: BaseUrl + '/public/appssource/all_icon/10_casino_YL.webp' },
            { name: 'DRAGONOFT', clickUrl: 'home-game/all-game?provider=jetgames', imgPath: BaseUrl + '/public/appssource/all_icon/11_casino_DRAGONSOFT.webp' },
            { name: 'PRAGMATICPLAY', clickUrl: 'home-game/all-game?provider=mplay', imgPath: BaseUrl + '/public/appssource/all_icon/12_casino_PRAGMATICPLAY.webp' },
            { name: 'PLAYTECH', clickUrl: 'home-game/all-game?provider=platipus', imgPath: BaseUrl + '/public/appssource/all_icon/13_casino_PLAYTECH.webp' },
            { name: 'YESBINGO', clickUrl: 'home-game/all-game?provider=triple-profits-games', imgPath: BaseUrl + '/public/appssource/all_icon/14_casino_YESBINGO.webp' },
            { name: 'SEXYBCRT', clickUrl: 'home-game/all-game?provider=civogaming', imgPath: BaseUrl + '/public/appssource/all_icon/15_casino_SEXYBCRT.webp' },
            { name: 'CRASH', clickUrl: 'home-game/all-game?provider=golden-race', imgPath: BaseUrl + '/public/appssource/all_icon/16_Lotto-Instant-Win.png' },
            { name: 'FASTSPIN', clickUrl: 'home-game/all-game?provider=golden-race', imgPath: BaseUrl + '/public/appssource/all_icon/16_casino_FASTSPIN.webp' },
            { name: 'PGSOFT', clickUrl: 'home-game/all-game?provider=spinmatic', imgPath: BaseUrl + '/public/appssource/all_icon/17_casino_PGSOFT.webp' },
            { name: 'EZUGI', clickUrl: 'home-game/all-game?provider=evoplay', imgPath: BaseUrl + '/public/appssource/all_icon/19_casino_EZUGI.webp' },
            { name: 'SUPERSPADE', clickUrl: 'home-game/all-game?provider=only-play', imgPath: BaseUrl + '/public/appssource/all_icon/20_casino_SUPERSPADE.webp' },
            { name: 'EVOLAY', clickUrl: 'home-game/all-game?provider=panga-games', imgPath: BaseUrl + '/public/appssource/all_icon/21_casino_EVOPLAY.webp' },
            { name: 'ONETOUCH', clickUrl: 'home-game/all-game?provider=superlotto-slots', imgPath: BaseUrl + '/public/appssource/all_icon/22_casino_ONETOUCH.webp' },
            { name: 'SPRIBE', clickUrl: 'home-game/all-game?provider=zeusplay', imgPath: BaseUrl + '/public/appssource/all_icon/23_casino_SPRIBE.webp' },
            { name: 'BOMBAYLIVE', clickUrl: 'home-game/all-game?provider=aviatrix', imgPath: BaseUrl + '/public/appssource/all_icon/18_casino_BOMBAYLIVE.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Slots: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'JILI', clickUrl: 'home-game/all-game?provider=lotto-instant-win', imgPath: BaseUrl + '/public/appssource/all_icon/2_casino_JILI.webp' },
            { name: 'JDB', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/9_casino_JDB.webp' },
            { name: 'PRAGMATICPLAY', clickUrl: 'home-game/all-game?provider=mplay', imgPath: BaseUrl + '/public/appssource/all_icon/12_casino_PRAGMATICPLAY.webp' },
            { name: 'PLAYTECH', clickUrl: 'home-game/all-game?provider=platipus', imgPath: BaseUrl + '/public/appssource/all_icon/13_casino_PLAYTECH.webp' },
            { name: 'REDTIGER', clickUrl: 'home-game/all-game?provider=evolution2', imgPath: BaseUrl + '/public/appssource/all_icon/6_casino_REDTIGER.webp' },
            { name: 'FC', clickUrl: 'home-game/all-game?provider=amigo-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/8_casino_FC.webp' },
            { name: 'YESBINGO', clickUrl: 'home-game/all-game?provider=triple-profits-games', imgPath: BaseUrl + '/public/appssource/all_icon/14_casino_YESBINGO.webp' },
            { name: 'SPADEGAMING', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/7_casino_SPADEGAMING.webp' },
            { name: 'EVOLAY', clickUrl: 'home-game/all-game?provider=panga-games', imgPath: BaseUrl + '/public/appssource/all_icon/21_casino_EVOPLAY.webp' },
            { name: 'DRAGONOFT', clickUrl: 'home-game/all-game?provider=jetgames', imgPath: BaseUrl + '/public/appssource/all_icon/11_casino_DRAGONSOFT.webp' },
            { name: 'ONETOUCH', clickUrl: 'home-game/all-game?provider=superlotto-slots', imgPath: BaseUrl + '/public/appssource/all_icon/22_casino_ONETOUCH.webp' },
            { name: 'FASTSPIN', clickUrl: 'home-game/all-game?provider=golden-race', imgPath: BaseUrl + '/public/appssource/all_icon/16_casino_FASTSPIN.webp' },
            { name: 'PGSOFT', clickUrl: 'home-game/all-game?provider=spinmatic', imgPath: BaseUrl + '/public/appssource/all_icon/17_casino_PGSOFT.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Type: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'Live', clickUrl: 'home-game/all-game?provider=zeusplay', imgPath: BaseUrl + '/public/appssource/all_icon/25_live.png' },
            { name: 'Slot', clickUrl: 'home-game/all-game?provider=macaw-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/26_slot.png' },
            { name: 'Esports', clickUrl: 'home-game/all-game?provider=triple-cherry', imgPath: BaseUrl + '/public/appssource/all_icon/27_esports.png' },
            { name: 'Fishing', clickUrl: 'home-game/all-game?provider=fugaso', imgPath: BaseUrl + '/public/appssource/all_icon/28_fishing.png' },
            { name: 'Egame', clickUrl: 'home-game/all-game?provider=dlv', imgPath: BaseUrl + '/public/appssource/all_icon/29_egame_.png' },
            { name: 'Table', clickUrl: 'home-game/all-game?provider=rzugi', imgPath: BaseUrl + '/public/appssource/all_icon/30_table.png' },
            { name: 'Virtual', clickUrl: 'home-game/all-game?provider=cti-nteractive', imgPath: BaseUrl + '/public/appssource/all_icon/31_virual.png' },
            { name: 'Lotto', clickUrl: 'home-game/all-game?provider=amigo-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/32_lotto.png' },
            { name: 'Bingo', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/33_bingo.png' },
            { name: 'Crash', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/34_crash.png' },
            { name: 'Gameshow', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/35_gameshow.png' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Live: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'ROYALGAMING', clickUrl: 'home-game/all-game?provider=rzugi', imgPath: BaseUrl + '/public/appssource/all_icon/15_casino_SEXYBCRT.webp' },
            { name: 'EVOLUTION', clickUrl: 'home-game/all-game?provider=betgames', imgPath: BaseUrl + '/public/appssource/all_icon/4_casino_EVOLUTION.webp' },
            { name: 'EZUGI', clickUrl: 'home-game/all-game?provider=evoplay', imgPath: BaseUrl + '/public/appssource/all_icon/19_casino_EZUGI.webp' },
            { name: 'PRAGMATICPLAY', clickUrl: 'home-game/all-game?provider=mplay', imgPath: BaseUrl + '/public/appssource/all_icon/12_casino_PRAGMATICPLAY.webp' },
            { name: 'PLAYTECH', clickUrl: 'home-game/all-game?provider=platipus', imgPath: BaseUrl + '/public/appssource/all_icon/13_casino_PLAYTECH.webp' },
            { name: 'BETGAMES', clickUrl: 'home-game/all-game?provider=cti-nteractive', imgPath: BaseUrl + '/public/appssource/all_icon/5_casino_BETGAMES.webp' },
            { name: 'ROYALGAME', clickUrl: 'home-game/all-game?provider=ho-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/1_casino_royal.webp' },
            { name: 'SUPERSPADE', clickUrl: 'home-game/all-game?provider=only-play', imgPath: BaseUrl + '/public/appssource/all_icon/20_casino_SUPERSPADE.webp' },
            { name: 'ONETOUCH', clickUrl: 'home-game/all-game?provider=superlotto-slots', imgPath: BaseUrl + '/public/appssource/all_icon/22_casino_ONETOUCH.webp' },
            { name: 'BOMBAYLIVE', clickUrl: 'home-game/all-game?provider=aviatrix', imgPath: BaseUrl + '/public/appssource/all_icon/18_casino_BOMBAYLIVE.webp' },
            { name: 'BIGGAMING', clickUrl: 'home-game/all-game?provider=aviatrix', imgPath: BaseUrl + '/public/appssource/all_icon/36_BIGGAMING.webp' },
            { name: 'SV388', clickUrl: 'home-game/all-game?provider=amigo-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/37_SV388.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Table: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'KINGMAKER', clickUrl: 'home-game/all-game?provider=ho-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/3_casino_KINGMAKER.webp' },
            { name: 'JILI', clickUrl: 'home-game/all-game?provider=lotto-instant-win', imgPath: BaseUrl + '/public/appssource/all_icon/2_casino_JILI.webp' },
            { name: 'JDB', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/9_casino_JDB.webp' },
            { name: 'REDTIGER', clickUrl: 'home-game/all-game?provider=evolution2', imgPath: BaseUrl + '/public/appssource/all_icon/6_casino_REDTIGER.webp' },
            { name: 'SPRIBE', clickUrl: 'home-game/all-game?provider=zeusplay', imgPath: BaseUrl + '/public/appssource/all_icon/23_casino_SPRIBE.webp' },
                        { name: 'ROYALGAMING', clickUrl: 'home-game/all-game?provider=rzugi', imgPath: BaseUrl + '/public/appssource/all_icon/1_casino_royal.webp' },
            { name: 'PGSOFT', clickUrl: 'home-game/all-game?provider=spinmatic', imgPath: BaseUrl + '/public/appssource/all_icon/17_casino_PGSOFT.webp' },
            { name: 'BOMBAYLIVE', clickUrl: 'home-game/all-game?provider=aviatrix', imgPath: BaseUrl + '/public/appssource/all_icon/18_casino_BOMBAYLIVE.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Fishing: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'JILI', clickUrl: 'home-game/all-game?provider=lotto-instant-win', imgPath: BaseUrl + '/public/appssource/all_icon/2_casino_JILI.webp' },
            { name: 'FC', clickUrl: 'home-game/all-game?provider=amigo-gaming', imgPath: BaseUrl + '/public/appssource/all_icon/8_casino_FC.webp' },
            { name: 'JDB', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/9_casino_JDB.webp' },
            { name: 'YL', clickUrl: 'home-game/all-game?provider=gamebeat', imgPath: BaseUrl + '/public/appssource/all_icon/10_casino_YL.webp' },
            { name: 'YESBINGO', clickUrl: 'home-game/all-game?provider=triple-profits-games', imgPath: BaseUrl + '/public/appssource/all_icon/14_casino_YESBINGO.webp' },
            { name: 'SPADEGAMING', clickUrl: 'home-game/all-game?provider=rlysium-studios', imgPath: BaseUrl + '/public/appssource/all_icon/7_casino_SPADEGAMING.webp' },
            { name: 'PLAYTECH', clickUrl: 'home-game/all-game?provider=platipus', imgPath: BaseUrl + '/public/appssource/all_icon/13_casino_PLAYTECH.webp' },
            { name: 'FASTSPIN', clickUrl: 'home-game/all-game?provider=golden-race', imgPath: BaseUrl + '/public/appssource/all_icon/16_casino_FASTSPIN.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
      Lottery: (
        <div className="row d-flex justify-content-center">
          {[ 
            { name: 'NUMBER', clickUrl: 'home-game/all-game?provider=cti-nteractive', imgPath: BaseUrl + '/public/appssource/all_icon/38_provider-number.png' },
            { name: 'PRAGMATICPLAY', clickUrl: 'home-game/all-game?provider=mplay', imgPath: BaseUrl + '/public/appssource/all_icon/12_casino_PRAGMATICPLAY.webp' },
            { name: 'PLAYTECH', clickUrl: 'home-game/all-game?provider=platipus', imgPath: BaseUrl + '/public/appssource/all_icon/13_casino_PLAYTECH.webp' },
            { name: 'YESBINGO', clickUrl: 'home-game/all-game?provider=triple-profits-games', imgPath: BaseUrl + '/public/appssource/all_icon/14_casino_YESBINGO.webp' },
          ].map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1 d-flex justify-content-center"
              style={{backgroundColor: '#515151', borderLeft: '2px solid #282828', marginBottom : '2px' }}
            >
              <div
                className="p-2 rounded"
                style={{ textAlign: 'center'}}
              >

                <Link to={item.clickUrl}>
                <img
                  src={item.imgPath}
                  className="img-fluid rounded-circle"
                  alt={item.name}
                  width="60"
                  style={{ margin: '1px'}}
                />
                <h6 className="mt-1" style={{ color: '#002f6a', fontSize: '8px' }}>{item.name}</h6>
                </Link>

              </div>
            </div>
          ))}
        </div>
      ),
    };

    return content[id] || null;
  };


return(
     <>

      <span className="d-xl-block">
         <div className="row">
            <Fragment>
                <Carousel className="p-0">
                  {salider.map((carousel, i) => (
                    <Carousel.Item key={i}>
                      <img
                        src={BaseUrl+(carousel.img_link)}
                        className='d-block w-100'
                        alt={`Slide ${i + 1}`}
                        style={{ borderRadius: '10px' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel> 


            </Fragment> 
            </div>
      
          <div className="row">     
            <Fragment>
            <div style={{ backgroundColor: '#2d2d2d' }} className="marquee">
              <p style={{ marginBottom: '0px', padding: '3px', fontsize: '18px', color: 'white'}}>
                প্রিয় গ্রাহক, আপনার bajilive.net এ ভিজিট করতে সমস্যা হলে, অনুগ্রহ করে 112233bj.com, 221133bj.com ব্যবহার করুন, এটি আমাদের ব্যাকআপ ওয়েবসাইট লিংক।
              </p>
            </div> 
            </Fragment>
          </div> 


        <div className="row d-block d-sm-none">
            <Fragment>
              <Col xl="12" className="pl-1 mt-2" >
                <div className="row">
                  <div className="team-scroll d-flex" style={{ overflowX: 'auto', whiteSpace: 'nowrap', backgroundColor: '#2d2d2d' }}>
                    {teams.map((team) => (

                    <div 
                    style={{ cursor: 'pointer', width: '65px', borderradius: '10px', backgroundColor: activeTab === team.id ? '#5b5b5b' : '', transition: 'border-color 0.3s', marginRight: '15px', borderRadius: '13px',textAlign: 'center' }}
                    >
                      <img
                        key={team.id}
                        src={team.img}
                        className={`team-logo ${activeTab === team.id ? 'active' : ''}`}
                        alt={team.name}
                        onClick={() => setActiveTab(team.id)}
                      style={{ width: '65px', padding: '10px' }}
                      />
                     <h3 style={{ color: '#002f6a', fontSize: '10px' }}>{team.name}</h3>
                   </div>
                    ))}
                  </div>

                  <div className="tab-content mt-2" style={{ backgroundColor: '#2d2d2d', borderTop: 'none',  }}>
                    {renderTabContent(activeTab)}
                  </div>
                </div>
              </Col>
          </Fragment>
        </div> 



        <div className="row">     
            <Fragment>
              <Col xl="12" className="pl-1 mt-2" >
                <div className="row">


                    <div style={{ backgroundColor: '#2d2d2d' }} className="col-xl-6 col-xxl-6 col-lg-6 col-md-12 col-sm-12 col-12 int-col"> 
                          <div>
                            <h3 className="nav-button float-right">Favourites  </h3>
                          </div>
                          <div>
                            <button className="nav-button" onClick={prevRow1Image}>
                              &#8592;
                            </button>
                            <button className="nav-button" onClick={nextRow1Image}>
                              &#8594;
                            </button>
                            <img src={row1Images[row1Index]} alt="Row 1" className="image img-fluid" />
                          </div>  
                      </div> 

                    <div style={{ backgroundColor: '#2d2d2d' }} className="col-xl-6 col-xxl-6 col-lg-6 col-md-12 col-sm-12 col-12 int-col"> 

                          <div>
                            <h3 className="nav-button float-right">Favourites  </h3>
                          </div>                          
                          <div>
                            <button className="nav-button" onClick={prevRow2Image}>
                              &#8592;
                            </button>
                            <button className="nav-button" onClick={nextRow2Image}>
                              &#8594;
                            </button>
                            <img src={row2Images[row2Index]} alt="Row 2" className="image img-fluid" />
                          </div>  
                      </div> 

            
                </div>
              </Col>
          </Fragment>
        </div> 


        <div className="row">
            <Fragment>
              <Col xl="12" className="pl-1 mt-2" >
                <div className="row">
                 {homeitem.map((ele)=>(
                    <div  className="col-xl-3 col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-4 int-col p-1">  
                          <div key={ele.id}>
                            <Link
                                to={authToken ? { pathname:  ele.link } : "?login=true"}
                                className="text-black user-name"
                              >
                                <div className="img-bx">
                                    <img src={BaseUrl+(ele.img_link)} alt="" className=" me-3 card-list-img w-100" width="130" />
                                </div>  
                             </Link>
                          </div>  
                      </div> 
                  ))}
                </div>
              </Col>
          </Fragment>
        </div> 


      </span>
    </>
  )
}
export default Home;